import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "@/components/ScrollToTop";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Team from "@/pages/Team";
import Resources from "@/pages/Resources";
import Contact from "@/pages/Contact";
import Disclaimer from "@/pages/Disclaimer";
import Privacy from "@/pages/Privacy";
import Admin from "@/pages/Admin";
import NotFound from "@/pages/NotFound";
import {
  TaxDueDates, TaxRates, TaxRetentionGuide, TaxGlossary, TaxpayerRights,
  TaxForms, IRSPublications, WheresMyRefund, IRSWithholding,
} from "@/pages/ResourcePages";
import { SubscribeToTaxCalendar, TaxAppointmentChecklistPage } from "@/pages/ExtraResourcePages";

function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <BrowserRouter>
        <ScrollToTop />
        <a
          href="#main-content"
          data-testid="skip-to-content"
          className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[100] focus:bg-navy-800 focus:text-white focus:px-4 focus:py-2 focus:rounded"
        >
          Skip to main content
        </a>
        <Navbar />
        <div id="main-content" tabIndex={-1} className="flex-1 outline-none">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/team" element={<Team />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/resources/tax-due-dates" element={<TaxDueDates />} />
            <Route path="/resources/tax-rates" element={<TaxRates />} />
            <Route path="/resources/record-retention-guide" element={<TaxRetentionGuide />} />
            <Route path="/resources/tax-glossary" element={<TaxGlossary />} />
            <Route path="/resources/taxpayer-rights" element={<TaxpayerRights />} />
            <Route path="/resources/irs-forms" element={<TaxForms />} />
            <Route path="/resources/irs-publications" element={<IRSPublications />} />
            <Route path="/resources/refund" element={<WheresMyRefund />} />
            <Route path="/resources/withholding" element={<IRSWithholding />} />
            <Route path="/resources/subscribe-to-tax-calendar" element={<SubscribeToTaxCalendar />} />
            <Route path="/resources/tax-appointment-checklist" element={<TaxAppointmentChecklistPage />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/disclaimer" element={<Disclaimer />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
